<template>
  <div class="viewer" ref="viewContainer">
    <div class="viewer__hotspot--tooltip" v-if="tooltip">
      {{ tooltip }}
    </div>
    <div class="viewer__img" ref="viewer" @click="getHotspotLocations">
      <!-- De hotspots => foreach loop -->
      <div class="looper" v-for="(hotspot, index) in hotspots" :key="index">
        <div
          class="viewer__hotspot"
          ref="hotspot"
          :id="hotspot.field_hotspot_id"
          @click="toggleModal(index)"
          @mouseenter="showToolTip(index)"
          @mouseleave="clearToolTip"
        >
          <!-- v-if="hotspot.title" -->
          <span v-if="developerMode">{{ hotspot.field_hotspot_id }}</span>
        </div>
      </div>

      <div class="viewer__img--hotspots">
        <button class="viewer__img--resetter" v-if="developerMode">
          No hotspot
        </button>
      </div>
      <img
        :src="
          'https://www.twintrailer.be/modules/custom/twin_threesixty/images/' +
          location +
          '_' +
          currentIndex +
          '.jpg'
        "
        :alt="'trailer_image_' + currentIndex"
        class="viewer__img--img"
        ref="image"
        @mouseleave="clickRelease"
        @mousedown="clickHold"
        @mouseup="clickRelease()"
        @mousemove="drag"
      />
    </div>
    <!-- Knoppen -->
    <div class="viewer__actions" ref="actions">
      <button
        class="viewer__actions--left viewer__actions--disabled"
        @click="next"
      >
        <img
          class="viewer__actions--left--img"
          src="../assets/icons/left.png"
          alt=""
          srcset=""
        />
      </button>
      <button class="viewer__actions--right" @click="previous">
        <img
          class="viewer__actions--right--img"
          src="../assets/icons/left.png"
          alt=""
          srcset=""
        />
      </button>
      <button
        class="viewer__actions--zoom-in"
        @click="transformAction('zoomIn')"
        :disabled="translate.zoom === 9"
      >
        <img
          class="viewer__actions--zoom-in--img"
          src="../assets/icons/zoom-in.png"
          alt=""
          srcset=""
        />
      </button>
      <button
        class="viewer__actions--zoom-out"
        @click="transformAction('zoomOut')"
        :disabled="translate.zoom === 0"
      >
        <img
          class="viewer__actions--zoom-out--img"
          src="../assets/icons/zoom-out.png"
          alt=""
          srcset=""
        />
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "Viewer",
  props: {
    amount: {
      type: Number,
      default: 10,
    },
    hotspots: {
      type: Array,
      default: () => [],
    },
    location: {
      type: String,
      defaul: "",
    },
    images: {
      type: Array,
      default: () => [],
    },
    passedIndex: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      currentIndex: this.passedIndex,
      dragging: false,
      mousePosition: {
        x: 0,
        y: 0,
      },
      previousTranslate: {
        x: 0,
        y: 0,
      },
      translate: {
        x: 0,
        y: 0,
        zoom: 0,
      },
      dragSpeed: 100,
      dragCounter: 0,
      mouseDirectionString: "",
      developerMode: false,
      tooltip: "",
      hoverIndex: null,
    };
  },
  mounted() {
    this.$refs.image.addEventListener("touchstart", this.clickHold);
    this.$refs.image.addEventListener("touchend", this.clickRelease);
    this.$refs.image.addEventListener("touchmove", this.drag);
    document.addEventListener("keydown", this.changeImgByKeyboard);
    this.setFirstHotspot();
  },
  destroyed() {
    document.removeEventListener("keydown", this.changeImgByKeyboard);
  },
  watch: {
    // Eventlister die getriggered wordt als onderstaande variabelen een andere waarde krijgen
    currentIndex: {
      handler() {
        this.changeHotspot();
      },
      deep: true,
    },
    images: {
      handler() {
        // console.log("test");
      },
    },
    translate: {
      handler() {
        this.transform();
      },
      deep: true,
    },
    location: {
      handler() {
        this.currentIndex = 1;

        this.setFirstHotspot();
      },
      deep: true,
    },
  },
  methods: {
    showToolTip(hotspotID) {
      this.hoverIndex = hotspotID;
      this.tooltip = this.hotspots[hotspotID].title;
    },
    clearToolTip() {
      this.tooltip = "";
    },
    changeImgByKeyboard(e) {
      if (e.code === "ArrowLeft") {
        this.next();
      }
      if (e.code === "ArrowRight") {
        this.previous();
      }
    },
    getHotspotLocations(e) {
      if (!this.developerMode) {
        return;
      }
      if (!e.target.matches(".viewer__img--resetter")) {
        const containerWidth = this.$refs.viewer.clientWidth;
        const containerHeight = this.$refs.viewer.clientHeight;
        const percentageX = (e.offsetX / containerWidth) * 100;
        const percentageY = (e.offsetY / containerHeight) * 100;
        this.$emit("newHotspot", {
          x: Math.round(percentageX * 100) / 100,
          y: Math.round(percentageY * 100) / 100,
        });
      } else {
        this.$emit("newHotspot", { x: 0, y: 0 });
      }
    },

    /*******************
     * Transformaties
     ******************/
    next() {
      this.changeImg(true);
    },
    previous() {
      this.changeImg(false);
    },
    // Button handlers
    transformAction(action) {
      switch (action) {
        case "zoomIn":
          if (this.translate.zoom <= 9) {
            this.translate.zoom++;
          }
          break;
        case "zoomOut":
          if (this.translate.zoom >= 0) {
            this.translate.zoom--;
          }
          if (this.translate.zoom === 0) {
            // reset the translate position
            this.translate.x = 0;
            this.translate.y = 0;
          }
          break;
        default:
          break;
      }
    },
    // Deze wordt getriggered als de translate data gewijzigd wordt (in de watch)
    transform() {
      this.$refs.viewer.style.transform =
        "scale(1." +
        this.translate.zoom +
        ") translateY(" +
        this.translate.y +
        "%) translateX(" +
        this.translate.x +
        "%)";
    },
    /*******************
     * De click event van de een hotspot doorsturen naar de parent (App.vue)
     * nodig voor de modal
     ******************/
    toggleModal(hotspot) {
      this.$emit("hotspot-click", {
        id: hotspot,
        frameIndex: this.currentIndex,
      });
    },

    changeImg(left = true) {
      if (left === true) {
        if (this.currentIndex < this.amount) {
          this.currentIndex++;
        } else {
          this.currentIndex = 1;
        }
      } else {
        if (this.currentIndex === 1) {
          this.currentIndex = this.amount + 1;
        }
        this.currentIndex--;
      }
    },

    /*******************
     * Click methods (op de image)
     ******************/
    clickHold(e) {
      if (this.developerMode) {
        return;
      }
      e.preventDefault();
      this.dragging = true;
      this.mousePosition.x = e.x;
      this.mousePosition.y = e.y;
      if (e.touches) {
        e.preventDefault();
        this.mousePosition.x = e.touches[0].screenX;
        this.mousePosition.y = e.touches[0].screenY;
      }
    },
    clickRelease() {
      if (this.developerMode) {
        return;
      }
      this.dragging = false;
      this.dragCounter = 0;
    },
    drag(e) {
      if (this.developerMode) {
        return;
      }
      let x = e.x;
      let y = e.y;
      if (e.touches) {
        e.preventDefault();
        x = e.touches[0].screenX;
        y = e.touches[0].screenY;
      }
      if (this.dragging) {
        this.dragCounter++;
        if (this.dragCounter % 2 === 0) {
          if (this.translate.zoom === 0) {
            if (this.mousePosition.x > x) {
              this.changeImg(true);
            } else {
              this.changeImg(false);
            }
          } else {
            this.checkDragDirection(e);
            this.panImage(x, y);
          }
        }
      }
    },
    checkDragDirection(dir) {
      if (this.developerMode) {
        return;
      }
      let x = dir.x;
      let y = dir.y;
      if (dir.touches) {
        dir.preventDefault();
        x = dir.touches[0].screenX;
        y = dir.touches[0].screenY;
      }

      if (
        Math.abs(this.mousePosition.y - y) > Math.abs(this.mousePosition.x - x)
      ) {
        // drag goes vertical
        if (this.mousePosition.y < y) {
          this.mouseDirectionString = "up";
        } else {
          this.mouseDirectionString = "down";
        }
      } else {
        // drag goes horizontal
        if (this.mousePosition.x < x) {
          this.mouseDirectionString = "left";
        } else {
          this.mouseDirectionString = "right";
        }
      }
    },
    translateImage(x, y, reset = false) {
      if (!reset) {
        this.translate.x -= (this.mousePosition.x - x) / this.dragSpeed;
        this.translate.y -= (this.mousePosition.y - y) / this.dragSpeed;
        this.previousTranslate.x = this.translate.x;
        this.previousTranslate.y = this.translate.y;
      } else {
        this.translate.x = this.previousTranslate.x;
        this.translate.y = this.previousTranslate.y;
      }
    },
    panImage(x, y) {
      const viewContainer = this.$refs.viewContainer.getBoundingClientRect();
      const imageContainer = this.$refs.viewer.getBoundingClientRect();
      const actionsContainer = this.$refs.actions.getBoundingClientRect();

      switch (this.mouseDirectionString) {
        case "left":
          if (viewContainer.left >= imageContainer.left) {
            this.translateImage(x, y);
          } else {
            this.translateImage(x, y, true);
          }
          break;
        case "right":
          if (viewContainer.right <= imageContainer.right) {
            this.translateImage(x, y);
          } else {
            this.translateImage(x, y, true);
          }
          break;
        case "up":
          if (viewContainer.top >= imageContainer.top) {
            this.translateImage(x, y);
          } else {
            this.translateImage(x, y, true);
          }
          break;
        case "down":
          if (imageContainer.bottom >= actionsContainer.top) {
            this.translateImage(x, y);
          } else {
            this.translateImage(x, y, true);
          }
          break;
        default:
          break;
      }
    },
    /*******************
     * HOTSPOT Methods
     ******************/
    setFirstHotspot() {
      if (this.$refs.hotspot) {
        this.$refs.hotspot.forEach((hotspot, index) => {
          if (
            this.hotspots[index].locations[this.currentIndex - 1].x !== 0 ||
            this.hotspots[index].locations[this.currentIndex - 1].y !== 0
          ) {
            hotspot.style.left =
              "calc(" +
              this.hotspots[index].locations[this.currentIndex - 1].x +
              "% - 10px)";
            hotspot.style.top =
              "calc(" +
              this.hotspots[index].locations[this.currentIndex - 1].y +
              "% + 5px)";
          } else {
            this.$refs.hotspot[index].style.display = "none";
          }
        });
      }
    },
    changeHotspot() {
      if (this.$refs.hotspot) {
        this.hotspots.forEach((hotspot, index) => {
          if (hotspot.locations.length !== 0) {
            // Indien de hotspot locatie niet op 0 staat (0 = geen hotspot nodig)
            if (
              hotspot.locations[this.currentIndex - 1].x !== 0 &&
              hotspot.locations[this.currentIndex - 1].y !== 0
            ) {
              if (this.$refs.hotspot[index]) {
                this.$refs.hotspot[index].style.display = "block";

                this.$refs.hotspot[index].style.left =
                  "calc(" +
                  hotspot.locations[this.currentIndex - 1].x +
                  "% - 10px)";
                this.$refs.hotspot[index].style.top =
                  "calc(" +
                  hotspot.locations[this.currentIndex - 1].y +
                  "% + 5px)";
              }
            } else {
              if (this.$refs.hotspot[index]) {
                this.$refs.hotspot[index].style.display = "none";
              }
            }
          }
        });
      }
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/imports/media.scss";
.viewer {
  box-sizing: border-box;
  width: 100%;
  user-select: none;
  overflow: hidden;
  z-index: 9;
  &__hotspot {
    width: 20px;
    height: 20px;

    line-height: 1;
    padding: 0;
    background-color: #1a9dabc4;
    border: 4px solid #1b6b74c7;
    border: 4px solid #b6f4fffd;
    border-radius: 50%;
    position: absolute;
    top: 0;
    cursor: pointer;
    z-index: 1;
    // transform-origin: center center;
    transition: transform 200ms ease-in-out;
    &--tooltip {
      font-size: 0.8em;
      position: absolute;
      z-index: 20;
      left: 0;
      top: 0em;
      padding: 0.5em;
      background-color: #1a9cab;
      font-weight: bold;
      display: inline-block;
      width: max-content;
      text-overflow: ellipsis;
      // overflow: hidden;
      white-space: nowrap;
      // max-width: 200px;
      color: white;
    }
    span {
      color: red;
      display: inline-block;
      margin-top: 20px;
      margin-left: -40px;
      font-weight: bold;
      background-color: rgb(224, 250, 162);
      padding: 0.2em;
    }
    @include phone {
      width: 15px;
      height: 15px;
    }
    &:hover {
      transform: scale(1.1);
    }
  }
  &__img {
    user-drag: none;
    -webkit-user-drag: none;
    -khtml-user-drag: none;
    -moz-user-drag: none;
    -o-user-drag: none;
    user-select: none;
    position: relative;
    padding: 1em 0 2em 0;

    &--hotspots {
      display: flex;
      flex-direction: column;
      position: absolute;
      max-width: 150px;
      top: 10px;
      left: 0;
      z-index: 10;
    }

    img {
      width: 100%;
      user-drag: none;
      -webkit-user-drag: none;
      -khtml-user-drag: none;
      -moz-user-drag: none;
      -o-user-drag: none;
      user-select: none;
      position: relative;
    }
    &:hover {
      cursor: move;
    }
  }
  &__actions {
    z-index: 30;
    position: absolute;
    top: calc(100% - 26px);
    left: calc(50% - 150px);
    max-width: 300px;
    background-color: #1a9dab;
    border-radius: 30px;
    display: flex;
    // flex-direction: column;
    justify-content: center;
    align-items: center;
    &--left,
    &--right,
    &--zoom-in,
    &--zoom-out {
      display: flex;
      justify-content: center;
      align-items: center;

      height: 30px;
      &--img {
        width: 50%;
        @include phone {
          width: 50%;
        }
      }
      padding: 0;
      max-width: 80px;
      border: none;
      cursor: pointer;
      padding: 0.2em;
      margin: 0 0.2em;
      touch-action: manipulation;
      // border: 2px solid white;
      border-radius: 50px;
      color: white;
      background-color: transparent;
      transform: scale(1);
      transition: transform 300ms ease-in-out;
      &:hover {
        transform: scale(1.05);
      }
    }
    &--right {
      &--img {
        transform: rotate(180deg);
      }
    }
    padding: 0.5em;
  }
}
.preload {
  position: absolute;
  left: -9999px;
  top: -9999px;
}
</style>
